import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04cb6e7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cur-container",
  id: "cur-container"
}
const _hoisted_2 = { class: "cur-banner" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "types" }
const _hoisted_5 = { class: "bg" }
const _hoisted_6 = { class: "data-com" }
const _hoisted_7 = { class: "data" }
const _hoisted_8 = { class: "unit" }
const _hoisted_9 = { class: "type-name" }
const _hoisted_10 = { class: "cur-des" }
const _hoisted_11 = { class: "des-name" }
const _hoisted_12 = { class: "btns" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "cur-table" }
const _hoisted_15 = { class: "editable-cell" }
const _hoisted_16 = {
  key: 0,
  class: "editable-cell-input-wrapper"
}
const _hoisted_17 = {
  key: 1,
  class: "editable-cell-text-wrapper"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 剩余超标天数(天) ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
  /*#__PURE__*/_createElementVNode("div", null, "计算公式： "),
  /*#__PURE__*/_createElementVNode("div", null, "剩余超标天数=能超标天数-实际超标天数=（年度总天数-目标优良天）-（实际天数-实际优良天数）=年度总天数乘*(1-优良率)-(实际天数-实际优良天数) ；"),
  /*#__PURE__*/_createElementVNode("div", null, "注：若计算结果为负数，显示为0")
], -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 剩余控制值(ug/m3) ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
  /*#__PURE__*/_createElementVNode("div", null, "计算公式："),
  /*#__PURE__*/_createElementVNode("div", null, " 剩余控制值=总天数*目标累计浓度值-实际天数*实际累计浓度值/(总天数-实际天数）")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.curYear?_ctx.curYear+'年':'') + "年度目标", 1),
      _createElementVNode("button", {
        class: "anual-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toAnnualPage && _ctx.toAnnualPage(...args)))
      }, "历年目标"),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "type",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: _normalizeClass(['iconfont',item.icon])
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(item.data), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.unit), 1)
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.curYear?_ctx.curYear+'年':'') + "年度目标分解", 1),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: _normalizeClass(`btn ${index===_ctx.curType?'active':''}`),
            onClick: ($event: any) => (_ctx.changeType(index))
          }, _toDisplayString(item.name), 11, _hoisted_13))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
        default: _withCtx(() => [
          _createVNode(_component_Table, {
            columns: _ctx.columns,
            "data-source": _ctx.tableData,
            rowKey: record=>record.id,
            pagination: false,
            bordered: ""
          }, _createSlots({
            isQualified: _withCtx(({ text,}) => [
              _createElementVNode("div", {
                class: _normalizeClass(`completion ${text === '达标'?'':'red'}`)
              }, _toDisplayString(text), 3)
            ]),
            customTitle1: _withCtx(() => [
              _hoisted_19,
              _createVNode(_component_Tooltip, {
                color: "#fff",
                getPopupContainer: _ctx.getPopupContainer
              }, {
                title: _withCtx(() => [
                  _hoisted_20
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_QuestionCircleFilled)
                ]),
                _: 1
              }, 8, ["getPopupContainer"])
            ]),
            customTitle2: _withCtx(() => [
              _hoisted_21,
              _createVNode(_component_Tooltip, {
                color: "#fff",
                getPopupContainer: _ctx.getPopupContainer
              }, {
                title: _withCtx(() => [
                  _hoisted_22
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_QuestionCircleFilled)
                ]),
                _: 1
              }, 8, ["getPopupContainer"])
            ]),
            _: 2
          }, [
            _renderList(['decompose', 'current', 'lastYear'], (col) => {
              return {
                name: col,
                fn: _withCtx(({ text, index,record }) => [
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.tableIndex === index && _ctx.curCol ===col)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_InputNumber, {
                            value: _ctx.tmpInput,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tmpInput) = $event)),
                            onPressEnter: ($event: any) => (_ctx.save(index,col))
                          }, null, 8, ["value", "onPressEnter"]),
                          _createVNode(_component_CheckOutlined, {
                            class: "editable-cell-icon-check",
                            onClick: ($event: any) => (_ctx.save(index,col))
                          }, null, 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createTextVNode(_toDisplayString(text??' ') + " ", 1),
                          (record.month === '全年'&& _ctx.types[_ctx.curType].type === 'fineDays'&& col ==='decompose')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(" + _toDisplayString(_ctx.fineDaysRate(Number(text))) + "%)", 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_EditOutlined, {
                            class: "editable-cell-icon",
                            onClick: ($event: any) => (_ctx.edit(index,text,col))
                          }, null, 8, ["onClick"])
                        ]))
                  ])
                ])
              }
            })
          ]), 1032, ["columns", "data-source", "rowKey"])
        ]),
        _: 1
      }, 8, ["locale"])
    ])
  ]))
}